<template>
  <div class="message-button-delete" @click="remove">
    メッセージの削除
  </div>
</template>

<script>
export default {
  methods: {
    remove: function () {
      if (window.confirm('本当に削除しますか？')) {
        this.$router.go(-1)
        this.$store.dispatch('message/deleteMessage')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.message-button-delete {
  @include button-ol-danger;
}
</style>
